<template>
  <div class="profile">
    <ProfilePicture
      :uuid="user && user.status === 'deleted' ? null : user?.profile_picture?.uuid"
      :user-id="user && user.id"
      :user-firstname="user && user.status === 'deleted' ? trans('user.deleted.name') : userFirstname"
    />
    <p class="profile__infos profile-infos">
      <span class="profile-infos__name">
        {{ user && user.status === 'deleted' ? trans('user.deleted.name') : userFullname }}
      </span>
      <span v-if="userOrganizationName" class="profile-infos__orga">
        {{ user && user.status === 'deleted' ? '' : userOrganizationName }}
      </span>
    </p>
  </div>
</template>
<script>

import { translationMixin } from '@elements/translation';
import ProfilePicture from '@components/ProfilePicture.vue';

export default {
  name: 'Profile',
  components: { ProfilePicture },
  mixins: [ translationMixin ],
  props: {
    user: {
      type: Object,
      default: () => {
      },
    },
    showOrga: { type: Boolean, default: false },
    userFirstname: { type: String, default: '' },
    userFullname: { type: String, default: '' },
    userOrganizationName: { type: String, default: '' },
  },
};
</script>
